module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAASFBMVEUAAAAwwXw1wH4wwn0xwXxCvXExwnwwwnwxw30yv30xwnwwwnwyw3wxwnwxw3wxwXwxwnwywH0yw4A7xIAxwn0wwXsyv3syw30N3vZKAAAAGHRSTlMAgBJTGQZ9eEUecm9rZmBaSy4mDT86ODMJgYJaAAAAjElEQVQ4y+XRyRHCMBQEUbRbeLdZ8s+UYm7TRED53Xpu0r9dRNzWF5NiCyEkJgzhKzLdorUz3aQ1M13TejJdEKY7NTamy1onpju0Lky3a01M99S6MQUf/mC6pPXNdKvWg+lmrZ3p7loj01WthWmKxsp0UevIdF3rzBTcNzFd0XN2JuQx1IH5Kxbm//sAD1IE9x5BtJUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/liveroom-app-ic.png
// module id = 1949
// module chunks = 6